import React from 'react';
import './style.css';
import { motion } from "framer-motion";
// import TextImage from '../../assets/logoText.svg';
// import LeftImage from '../../assets/logoLeft.svg';

export const DotLoaderComp = ({ size = '' }) => {
  return (
    <div  className='flex items-center flex-col mt-16 justify-center'>
          <motion.div className="loader border-t-4 border-orange-500 border-solid rounded-full h-12 w-12"
      animate={{ rotate: 360 }}
      transition={{ duration: 1, repeat: Infinity, ease: "linear" }}></motion.div>
      
      <p className='font-bold text-[25px] text-orangeColor font-abhaya py-3'>Please Wait...</p>
    </div>
  );
};







